export type FileLibraryDocumentComment = {
  id: number;
  municipality_id: number;
  document_id: number;
  user_id: number;
  parent_id: number | null;
  author_name: string;
  body: string;
  created_at: string;
};

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

function commentsPath(municipalityId: number, documentId: number): string {
  return `/api/v1/municipalities/${municipalityId}/file_library/documents/${documentId}/comments`;
}

export async function listFileLibraryDocumentComments(
  municipalityId: number,
  documentId: number,
): Promise<FileLibraryDocumentComment[]> {
  const response = await fetch(commentsPath(municipalityId, documentId), {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error("Failed to load comments");
  }
  return response.json();
}

export async function createFileLibraryDocumentComment(
  municipalityId: number,
  documentId: number,
  body: string,
  parentId?: number | null,
): Promise<FileLibraryDocumentComment> {
  const response = await fetch(commentsPath(municipalityId, documentId), {
    method: "POST",
    credentials: "include",
    headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
    body: JSON.stringify({
      file_library_document_comment: {
        body,
        ...(parentId != null ? { parent_id: parentId } : {}),
      },
    }),
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.errors?.join(", ") ?? "Failed to post comment");
  }
  return response.json();
}
